// SegmentedControl — toggle group con un option activo. Pattern del mockup
// "SegmentedPill" en crud-shared.jsx.
//
//   <SegmentedControl
//     value={period}
//     onChange={setPeriod}
//     options={[
//       { value: 'dia', label: 'Día' },
//       { value: 'semana', label: 'Semana' },
//       { value: 'mes', label: 'Mes' },
//     ]}
//   />

import { cn } from '../../lib/utils';

interface SegmentedControlProps<T extends string> {
  value: T;
  onChange: (v: T) => void;
  options: { value: T; label: string }[];
  className?: string;
  /** Tamaño compacto (h-8) o normal (h-10). */
  size?: 'sm' | 'md';
}

export function SegmentedControl<T extends string>({
  value,
  onChange,
  options,
  className,
  size = 'md',
}: SegmentedControlProps<T>) {
  return (
    <div
      role="tablist"
      className={cn(
        'inline-flex items-center rounded border border-border bg-surface-overlay p-0.5',
        className,
      )}
    >
      {options.map((opt) => {
        const active = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(opt.value)}
            className={cn(
              'rounded px-3 text-xs font-medium transition-colors',
              size === 'sm' ? 'h-7' : 'h-9',
              active
                ? 'bg-surface-elevated text-fg shadow-subtle'
                : 'text-fg-secondary hover:text-fg',
            )}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
